module.exports = __webpack_public_path__ + "img/home-comments-inner.0ec2206e.png";